"use client";

import { ReactNode } from "react";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v15-appRouter";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { rmhTheme } from "../theme";

export interface RmhThemeProviderProps {
  children: ReactNode;
  nonce?: string;
}

export const RmhThemeProvider = ({
  children,
  nonce,
}: RmhThemeProviderProps) => (
  <AppRouterCacheProvider options={{ key: "rmh-ds", prepend: true, nonce }}>
    <ThemeProvider theme={rmhTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  </AppRouterCacheProvider>
);
